<mat-sidenav-container class="layout-shell">
  <mat-sidenav
    #sidenav
    class="layout-sidebar"
    [mode]="isDesktop() ? 'side' : 'over'"
    [opened]="isDesktop()"
    fixedInViewport="false"
  >
    <a routerLink="/welcome" class="layout-brand" aria-label="Brijj Sports home">
      <app-brijjsports-wordmark size="md" />
    </a>

    <nav class="layout-nav" aria-label="Primary">
      @for (sec of nav.sections(); track sec.title) {
        @if (sec.title) {
          <div class="layout-nav__title">{{ sec.title }}</div>
        }
        @for (item of sec.items; track item.route) {
          <a class="layout-nav__item" [routerLink]="item.route" routerLinkActive="layout-nav__item--active">
            <app-icon [name]="item.icon" [size]="16" />
            <span>{{ item.label }}</span>
          </a>
        }
      }
    </nav>
  </mat-sidenav>

  <mat-sidenav-content class="layout-main">
    <mat-toolbar class="layout-toolbar">
      @if (!isDesktop()) {
        <button mat-icon-button (click)="sidenav.toggle()" aria-label="Toggle navigation">
          <app-icon name="menu" [size]="20" />
        </button>
      }

      <div class="layout-toolbar__crumbs">
        <span class="layout-toolbar__role">{{ subjectKindLabel() }}</span>
        <span class="layout-toolbar__sep">›</span>
        <app-breadcrumbs />
      </div>

      <span class="spacer"></span>

      @if (!tenants.isRoot()) {
        <app-sport-switcher />
        <app-notifications-bell />
      }

      <span class="layout-toolbar__tenant" [attr.title]="tenantDisplayName()">
        <app-icon name="building" [size]="14" />
        <span class="layout-toolbar__tenant-name">{{ tenantDisplayName() }}</span>
      </span>

      <button
        type="button"
        class="layout-toolbar__user-btn"
        [matMenuTriggerFor]="userMenu"
        aria-haspopup="menu"
        [attr.aria-label]="'Account menu for ' + subjectName()"
      >
        <span class="layout-toolbar__avatar" aria-hidden="true">{{ subjectInitials() }}</span>
        <span class="layout-toolbar__user-stack">
          <span class="layout-toolbar__user-name">{{ subjectName() }}</span>
          <span class="layout-toolbar__user-role">{{ subjectKindLabel() }}</span>
        </span>
        <app-icon name="chevron-down" [size]="14" />
      </button>

      <mat-menu #userMenu="matMenu" class="user-menu" xPosition="before">
        @if (profileRoute(); as route) {
          <a mat-menu-item [routerLink]="route">
            <mat-icon>person_outline</mat-icon>
            <span>My profile</span>
          </a>
        }
        @if (!tenants.isRoot()) {
          <button mat-menu-item type="button" (click)="resetDemo()">
            <mat-icon>refresh</mat-icon>
            <span>Reset demo</span>
          </button>
        }

        <mat-divider />

        <button mat-menu-item type="button" (click)="signOut()" class="user-menu__danger">
          <mat-icon>logout</mat-icon>
          <span>Sign out</span>
        </button>
      </mat-menu>
    </mat-toolbar>

    <main id="main-content" tabindex="-1" class="layout-content">
      <router-outlet />
    </main>

    @if (!isDesktop()) {
      <app-bottom-nav />
    }
  </mat-sidenav-content>
</mat-sidenav-container>
